import React from "react";

function initials(name) {
  if (!name) return "·";
  const parts = name.trim().split(/\s+/);
  const first = parts[0]?.[0] || "";
  const last = parts.length > 1 ? parts[parts.length - 1][0] : "";
  return (first + last).toUpperCase();
}

export const Monogram = ({ name, size = 56, dark = false }) => (
  <div
    className="flex items-center justify-center select-none hairline"
    style={{
      width: size,
      height: size,
      borderRadius: 4,
      background: dark ? "#111D33" : "#FAF7F2",
      color: dark ? "#E8D5A3" : "#1B2A4A",
      fontFamily: "'Cormorant Garamond', serif",
      fontSize: Math.floor(size * 0.42),
      letterSpacing: "0.05em",
    }}
    data-testid="profile-monogram"
  >
    {initials(name)}
  </div>
);

export default Monogram;
